import { fieldType } from 'components/FormCreatorComponent/types';
import type { ISystemMessageCompanyContact } from 'types/system-messages.types';

export const buildDateRangeField = (label: string, value: { startDate: Date; endDate: Date }) => ({
	type: fieldType.dateRangePicker,
	props: {
		name: 'dateRange',
		label,
		value,
		isInFuture: true,
	},
});

export const getHtmlText = (html: string) =>
	new DOMParser().parseFromString(html, 'text/html').body.textContent?.trim() ?? '';

export const combineDateAndTime = (date: Date, time: string): Date => {
	const [hours, minutes] = time.split(':').map(Number);
	const combined = new Date(date);
	combined.setHours(hours, minutes, 0, 0);
	return combined;
};

export const getContactDisplayName = (contact: ISystemMessageCompanyContact) =>
	`${contact.firstName} ${contact.lastName}`.trim();

const CONTACT_ID_SPLIT = /[\s,;]+/;
const CONTACT_ID_OK = /^[1-9]\d*$/;

export const getContactIdsFromRaw = (raw: string) => {
	const tokens = raw.split(CONTACT_ID_SPLIT).map((s) => s.trim()).filter(Boolean);
	const formatError =
		tokens.length > 0 &&
		tokens.some((t) => {
			if (!CONTACT_ID_OK.test(t)) return true;
			const n = Number(t);
			return !Number.isSafeInteger(n) || n > 2147483647;
		});
	return { formatError, ids: formatError ? [] : Array.from(new Set(tokens.map(Number))) };
};

export const hasSameContactIds = (left: number[], right: number[]) =>
	left.length === right.length && left.every((id, index) => id === right[index]);
